import Vue from 'vue';
import moment from 'moment';

Vue.filter('displayDate', (value, format) => {
  return moment(new Date(value)).format(format);
});

export default {};
